export const widthOfDrawer = 300;
export const getFlagEmoji = countryCode => <img
src={`https://flagcdn.com/${countryCode?.toLowerCase()}.svg`}
width="20"
alt={countryCode} />
